import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import ReCAPTCHA from "react-recaptcha";
import ErrorBoundary from './ErrorBoundary';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as utility from '../data/Utility';
import './Common.css'

class SignInInternal extends React.Component {
    constructor(props) {
        super(props);

        const clearCallback = utility.propCheck(props.clearCallback, null);
        this.state = {
            captcha: null,
            clearCallback: clearCallback,
            error: false,
            message: "",
            password: "",
            spinner: false,
            userName: "",
			verified: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleUserName = this.handleUserName.bind(this);
        this.callbackReCaptcha = this.callbackReCaptcha.bind(this);
        this.callbackReCaptchaVerified = this.callbackReCaptchaVerified.bind(this);
        this.setReCaptcha = this.setReCaptcha.bind(this);
    }

    handleClick() {
        if (this.state.clearCallback != null) {
            this.state.clearCallback();
        }
        this.setState({
            error: false,
            message: ""
        });

        const userName = this.state.userName;
        const password = this.state.password;
        if (userName === "" ||
            password === "") {
            this.setState({
                error: true,
                message: this.props.localizerState.badInputError
            });
        }
        else {
			var captchaResponse = this.state.captchaResponse;
			var message = "";

            this.setState({
                spinner: true
            });
            (async () => {
                message = await this.props.accountsDispatch.signIn(userName, password, captchaResponse, false);
            })().then(() => {
				/* Always stop the spinner whenever we return from API call to signIn() */
				this.setState({
					spinner: false
				});
                const accountsState = this.props.accountsState;
                if (!accountsState.authenticated) {
                    const captcha = this.state.captcha;
                    if (captcha != null) {
                        captcha.reset();
                    }

                    this.setState({
                        error: true,
						verified: false,
                        message: message,
                    });
                }
            });
        }
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    }

    handlePassword(e) {
        if (this.state.clearCallback != null) {
            this.state.clearCallback();
        }

        this.setState({
            password: e.target.value
        });
    }

    handleUserName(e) {
        if (this.state.clearCallback != null) {
            this.state.clearCallback();
        }

        this.setState({
            userName: e.target.value
        });
    }

	callbackReCaptcha() {
		this.setState({
			verified: false,
			captchaResponse: ""
		});
	}

	callbackReCaptchaVerified(response) {
		this.setState({
			verified: true,
			captchaResponse: response
		});
    }

    setReCaptcha(el) {
        if (this.state.captcha == null &&
            el != null) {
            this.setState({
                captcha: el
            });
        }
    }

    render() {
        const error = this.state.error;
        const forgotPassword = "Forgot Password";
        const message = this.state.message;
        const password = this.props.localizerState.password;
        const signIn = this.props.localizerState.signIn;
        const userName = this.props.localizerState.userName;

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

		const SITE_KEY="6LfPf-MUAAAAADfxy06t9VsDPs1ig7pfPTVCqOr-";	// from Google Account: hcsvalidation.gmail.com

        return (
            <Form>
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <FormGroup>
                    <Label for="userNameInput">{userName}</Label>
                    <Input className="input" id="userNameInput" onChange={this.handleUserName} onKeyDown={this.handleKeyDown} title={userName}/>
                </FormGroup>
                <div>
                    <Label for="passwordInput">{password}</Label>
                    <Input className="input" id="passwordInput" onChange={this.handlePassword} onKeyDown={this.handleKeyDown} title={password} type="password"/>
                </div>
                <div className="button-gap">
				<ReCAPTCHA
					sitekey={SITE_KEY}
					onloadCallback={this.callbackReCaptcha}
					verifyCallback={this.callbackReCaptchaVerified}
                    ref={el => { this.setReCaptcha(el) }}
				/>
                </div>
                <div className="button-gap">
                    <Button disabled={!this.state.verified} className="button" onClick={this.handleClick} title={signIn}>
                        {signIn}
                    </Button>{' '}
                    {this.state.spinner && <div className="spinner-border spinner-border-sm"></div>}
                    <FormGroup />
                    <Button disabled={!this.state.verified} className="button" tag={Link} title={forgotPassword} to={paths.forgotPassword}>
                        {forgotPassword}
                    </Button>
                </div>
            </Form>
        );
    }
}

const SignInConnect = connect(
    state => ({
        accountsState: state.accounts,
        localizerState: state.localizer
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch)
    })
)(SignInInternal);

export default class SignIn extends React.Component {
    render() {
        const clearCallback = utility.propCheck(this.props.clearCallback, null);

        return (
            <ErrorBoundary>
                <SignInConnect clearCallback={clearCallback} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SignIn.js